import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories, siteInfo } from '@/mocks/movies';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMobileOpen(false); }, [location]);

  const isActive = (path: string) => location.pathname === path;

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70' : 'bg-transparent'
      }`}
      aria-label="主导航"
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <span className="text-2xl md:text-3xl font-black font-heading text-primary-500 tracking-tight">51</span>
            <span className="text-lg md:text-xl font-bold font-heading text-foreground-900">影院</span>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            <Link
              to="/"
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                isActive('/') ? 'bg-primary-500 text-background-50' : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200'
              }`}
            >
              首页
            </Link>
            {categories.map(cat => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname.includes(cat.slug)
                    ? 'bg-primary-500 text-background-50'
                    : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/about"
              className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                isActive('/about') ? 'bg-primary-500 text-background-50' : 'text-foreground-700 hover:text-foreground-900 hover:bg-background-200'
              }`}
            >
              关于我们
            </Link>
          </div>

          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-foreground-700"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="切换菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-1">
            <Link to="/" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-200 cursor-pointer">首页</Link>
            {categories.map(cat => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-200 cursor-pointer">{cat.name}</Link>
            ))}
            <Link to="/about" className="px-4 py-3 rounded-lg text-sm font-medium text-foreground-700 hover:bg-background-200 cursor-pointer">关于我们</Link>
          </div>
        </div>
      )}
    </nav>
  );
}